import React from 'react'
import {SortableHandle as SortableHandleComponent} from 'react-sortable-hoc';
import IconDragButton from 'components/button/IconDragButton'

const SortableHandle = SortableHandleComponent((props) => {

    return (
        <IconDragButton/>
    )
})

export default SortableHandle;